<template>
  <div class="copyright">
    <div class="copyright-text" v-html="copyright"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      copyright: '© 版权所有&nbsp;&nbsp;&nbsp;上海文华财经资讯股份有限公司<br>ICP备案号：<a href="https://beian.miit.gov.cn" target="_blank" style="color: #fff;text-decoration: none;">沪ICP备09042590号-2</a>'
    }
  }
}
</script>

<style scoped>
.copyright {
  height: 2.2rem;
  width: 100%;
  position: relative;
  background-color: rgb(31, 40, 105);
  font-size: 0.508rem;
  color: #fff;
  text-align: center;
}
.copyright-text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  width: 100%;
  line-height: 1.5;
}
.copyright-text a {
  color: #fff;
  text-decoration: none;
}
</style>